import { useMutation } from "@tanstack/react-query";
import { extractDataFromFiles } from "@/lib/file-extraction";
import type {
  ExtractFileDataInput,
  ExtractFileDataOutput,
} from "@/lib/file-extraction";

export function useExtractFileData() {
  return useMutation<ExtractFileDataOutput, Error, ExtractFileDataInput>({
    mutationFn: extractDataFromFiles,
  });
}
